import React, { useEffect, useMemo, useState } from "react";
import Select from 'react-select';
import moment from 'moment';

import PanelTemplate from "../../templates/Panel";
import Table from "../../components/Table";
import Box from "../../components/Box";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import PageHeader from "../../components/PageHeader";
import FilterSimple from "../../components/FilterSimple";
import DotStatus from "../../components/DotStatus";
import { useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import api from "../../services/api";
import { toast } from "react-toastify";
import { renderError } from "../../helpers/errors";
import axios from "axios";
import InputRadio from "../../components/InputRadio";
import origins from "../../seeds/origins";
import { createOptions } from "../../helpers/selects";
import { ModalDelete } from "../../components/ModalDelete";
import { getToken, hasPermission } from "../../services/auth";
import Pagination from "../../components/Pagination";
import SelectCustomerCompany from "../../components/selects/SelectCustomerCompany";
import { getSubdomain } from "../../helpers/domain";
import { ModalCreateCustomer } from "../../components/ModalCreateCustomer";
import SortHeader from "../../components/SortHeader";

const types = [
    {label: 'Fornecedor de gravação', value: 'customization'},
    {label: 'Fornecedor de produto', value: 'product'},
    {label: 'Cliente', value: 'customer'},
    {label: 'Faturamento', value: 'billing'}
];

const indexMap = [
    { index: 'Código', value: 'code' },
    { index: 'Nome', value: 'name' },
    { index: 'E-mail', value: 'email' },
    { index: 'Cadastrado em', value: 'created_at' },
    { index: 'Atualizado em', value: 'updated_at' },
];

const customerSearchParams = [
    {name: 'Nome', key: '[name]', operation: 'contain', type: 'text' },
    {name: 'E-mail', key: '[email]', operation: 'contain', type: 'text' },
    {name: 'Código', key: '[code]', operation: 'contain', type: 'text' },
    {name: 'Nome da empresa', key: '[related][companies.trade_name]', operation: 'contain', type: 'text' },
    {name: 'Razão social da empresa', key: '[related][companies.company_name]', operation: 'contain', type: 'text' },
];

const getCustomerSearchParam = field => (
    customerSearchParams.find(param => param.key === field) || customerSearchParams[0]
);

const normalizePage = page => {
    const parsedPage = parseInt(page, 10);
    return Number.isNaN(parsedPage) || parsedPage < 1 ? 1 : parsedPage;
};

const parseCustomerListFilters = search => {
    const params = new URLSearchParams(search);
    const searchParam = getCustomerSearchParam(params.get('search_field'));

    return {
        page: normalizePage(params.get('page')),
        searchField: searchParam.key,
        searchOperation: params.get('search_operation') || searchParam.operation || 'contain',
        search: params.get('search') || '',
        ordenationItem: params.get('sort') || 'name',
        orientation: params.get('orientation') || 'asc',
    };
};

const buildCustomerApiQuery = filters => {
    const params = new URLSearchParams();

    if (filters.search.trim() !== '') {
        params.append(`filters[0]${filters.searchField}[${filters.searchOperation}]`, filters.search.trim());
    }

    params.set('ordenation_item', filters.ordenationItem);
    params.set('orientation', filters.orientation);
    params.set('page', filters.page);

    return params.toString();
};

const buildCustomerListSearch = filters => {
    const params = new URLSearchParams();

    if (filters.page > 1) params.set('page', filters.page);
    if (filters.search.trim() !== '') {
        params.set('search_field', filters.searchField);
        params.set('search_operation', filters.searchOperation);
        params.set('search', filters.search.trim());
    }
    if (filters.ordenationItem !== 'name') params.set('sort', filters.ordenationItem);
    if (filters.orientation !== 'asc') params.set('orientation', filters.orientation);

    return params.toString();
};

export const CustomerList = () => {
    const [loading, setLoading] = useState(false);

    const [customers, setCustomers] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [data, setData] = useState({header: [], rows: []});

    const [showCreateCustomer, setShowCreateCustomer] = useState(false);

    const [customerName, setCustomerName] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerCompanies, setCustomerCampanies] = useState([]);
    const [customerAdmin, setCustomerAdmin] = useState(null);
    const [customerType, setCustomerType] = useState([]);

    const [customerToDelete, setCustomerToDelete] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [totalResults, setTotalResults] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPrevPage, setHasPrevPage] = useState(false);

    const [selectedIds, setSelectedIds] = useState([]);
    const [showConfirmMultipleDelete, setShowConfirmMultipleDelete] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const customerFilters = useMemo(() => parseCustomerListFilters(location.search), [location.search]);

    const updateCustomerListUrl = (changes, resetPage = true) => {
        const nextFilters = {
            ...customerFilters,
            ...changes,
            page: resetPage ? 1 : (changes.page || customerFilters.page),
        };
        const search = buildCustomerListSearch(nextFilters);

        navigate({
            pathname: location.pathname,
            search: search ? `?${search}` : '',
        });
    }

    const handleOrdenation = (orientationItem, oredenation) => {
        updateCustomerListUrl({
            ordenationItem: orientationItem,
            orientation: oredenation,
        });
    };

    useEffect(() => {
        getCustomers();
    }, [location.search]);

    useEffect(() => {
        if(!showCreateCustomer) clean();
    }, [showCreateCustomer]);

    useEffect(() => {
        setTypesAndAdmin();
    }, [customerCompanies]);

    useEffect(() => {
        generateData();
    }, [customers, location.search]);

    const setTypesAndAdmin = () => {
        let selectedAdmin = customerAdmin;
        let selectedTypes = [...customerType];
        let selectedCompanies = companies.filter(company => customerCompanies.includes(company.id));
        selectedCompanies.map(selectedCompany => {
            if(selectedCompany.admin_id !== null){
                selectedAdmin = selectedCompany.admin_id;
            }
            selectedCompany.type.map(type => {
                if(!selectedTypes.includes(type)){
                    selectedTypes.push(type);
                }
            });
        });
        setCustomerType(selectedTypes);
        setCustomerAdmin(selectedAdmin);
    }

    const generateData = () => {
        let header = ['Código', 'Nome', 'E-mail', 'Telefone', 'Empresa', 'Cadastrado em', 'Atualizado em'];
        const rows = [];

        if(hasPermission('delete_customer')){
            header.push('');
        }

        customers.map(customer => {
            const companies = customer.companies.map(company => company.trade_name).join(', ');
            const returnTo = encodeURIComponent(`/customer/list${location.search}`);

            let buttons = [];

            if(hasPermission('delete_customer')){
                buttons.push(
                    <Button type={`delete`} svg={`delete`} action={() => setCustomerToDelete(customer.id)} />
                )
            }
            rows.push({
                data: [
                    customer.code,
                    customer.name,
                    customer.email,
                    customer.phone,
                    companies,
                    customer.created_at ? moment(customer.created_at).format('DD/MM/YYYY HH:mm') : '',
                    customer.created_at ? moment(customer.updated_at).format('DD/MM/YYYY HH:mm') : ''
                ],
                buttons,
                id: customer.id,
                to: `/customer/edit/${customer.id}?return_to=${returnTo}`
            })
        });

        setData({header, rows});
    }

    const getCustomers = () => {
        setCustomers([]);
        setLoading(true);

        api.get(`/customer/paginate?${buildCustomerApiQuery(customerFilters)}`).then(res => {
            setCustomers(res.data.resources.data);
            setCurrentPage(res.data.resources.current_page);
            setLastPage(res.data.resources.last_page)
            setPerPage(res.data.resources.per_page)
            setTotalResults(res.data.resources.total)
            setHasNextPage(res.data.resources.next_page_url !== null);
            setHasPrevPage(res.data.resources.prev_page_url !== null);
        }).catch(error => {
            
        }).then(() => setLoading(false));
    }

    const clean = () => {
        setCustomerName('');
        setCustomerEmail('');
        setCustomerPhone('');
        setCustomerCampanies([]);
    }

    const deleteCustomer = () => {
        setLoading(true);

        api.delete(`/customer/${customerToDelete}`).then(res => {
            setCustomerToDelete(null);
            getCustomers();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const handleSetFilter = (value, metadata) => {
        updateCustomerListUrl({
            searchField: metadata?.field || customerFilters.searchField,
            searchOperation: metadata?.operation || customerFilters.searchOperation,
            search: metadata?.value ?? '',
        });
    }

    const handleSetPage = page => {
        updateCustomerListUrl({ page }, false);
    }

    const deleteMultipleCustomers = () => {
        setLoading(true);

        api.delete(`/customer/multiple`, {
            data: {
                ids: selectedIds
            }
        }).then(res => {
            setSelectedIds([]);
            getCustomers();
            setShowConfirmMultipleDelete(false);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const exportCustomers = () => {
        window.open(`${process.env.REACT_APP_URL}/customer/export?_token=${getToken()}&_subdomain=${getSubdomain()}`);
    }

    const customerStored = customer => {
        navigate(`/customer/edit/${customer.id}`);
        setShowCreateCustomer(false);
    }

    return (
        <>
            <ModalDelete
                show={customerToDelete !== null}
                action={deleteCustomer}
                loading={loading}
                close={() => setCustomerToDelete(null)}
            />
            <ModalDelete
                show={showConfirmMultipleDelete}
                text={<p>Tem certeza que deseja apagar <strong>{selectedIds.length} {selectedIds.length > 1 ? 'pessoas' : 'pessoa'}</strong>?</p>}
                action={deleteMultipleCustomers}
                loading={loading}
                close={() => setShowConfirmMultipleDelete(false)}
            />
            <ModalCreateCustomer
                show={showCreateCustomer}
                close={() => setShowCreateCustomer(false)}
                customerStored={customerStored}
            />
            <PanelTemplate id="customer-list">
                <PageHeader
                    left={
                        <FilterSimple
                            params={customerSearchParams}
                            filter={handleSetFilter}
                            externalValue={customerFilters.search}
                            externalOption={customerFilters.searchField}
                        />
                    }

                    right={
                        <>
                            {hasPermission('delete_customer') && selectedIds.length > 0 &&
                                <Button 
                                type={`secondary`} 
                                size={`small`} 
                                svg={`delete`}
                                text={`Excluir ${selectedIds.length} selecionados`} 
                                action={() => setShowConfirmMultipleDelete(true)}  
                                />
                            }
                            {hasPermission('export_customer') &&
                                <Button type={`secondary`} size={`small`} text={`Exportar pessoas`} action={exportCustomers}  />
                            }
                            {hasPermission('create_customer') &&
                                <Button type={`primary`} size={`small`} text={`Cadastrar pessoa`} svg="plus-white" action={() => setShowCreateCustomer(true)}  />
                            }
                        </>
                    }
                />
                
                <Box className={`no-padding with-pagination`}>
                    <Table 
                        header={data.header} 
                        rows={data.rows} 
                        loading={loading}
                        checks={hasPermission('delete_customer')}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        sortOrdenationAction={(index) => (
                        <SortHeader
                            index={index}
                            ordenationItem={customerFilters.ordenationItem}
                            orientation={customerFilters.orientation}
                            onSort={handleOrdenation}
                            indexMap={indexMap}
                            />
                        )}
                    />
                </Box>
                {!loading &&
                    <Pagination
                        currentPage={currentPage}
                        lastPage={lastPage}
                        perPage={perPage}
                        totalResults={totalResults}
                        hasNextPage={hasNextPage}
                        hasPrevPage={hasPrevPage}
                        setCurrentPage={handleSetPage}
                    />
                }
            </PanelTemplate>
        </>
    );
}

export default CustomerList;